import { saveEditedWork } from "@/api/work";
// import fullModal from '@/assets/js/fullModal'
import { message } from 'ant-design-vue'
import i18n from '@/i18n/langs'
import Vue from "vue";

const state = {
  vrbase: {},
  currentScenesId: "scene_1",
  currentGuidePointId: "",
  currentHlookat: 0,
  selectImgIndex: 0,
}

const mutations = {
  SET_VR_BASE(state, vrbase) {
    console.log(
      'SET_VR_BASE',
      '\nvrbase:', vrbase
    );
    state.vrbase = vrbase;
  },
  SET_CURRENT_SCEN_ID(state, id) {
    console.log('SET_CURRENT_SCEN_ID:', id);
    state.currentScenesId = id;
  },
  DEL_VR_BASE(state) {
    state.vrbase = null
  },
  SET_CURRENT_GUIDE_POINT_ID(state, id) {
    state.currentGuidePointId = id;
  },
  SET_CURRENT_HLOOKAT(state, hlookat) {
    state.currentHlookat = hlookat;
  },
  SET_EDIT_SANDTABLE(state, sandtable) {
    if (state.vrbase.sandtable.length > 0) {
      // state.vrbase.sandtable = [sandtable];
      // state.vrbase.sandtable[state.selectImgIndex] = sandtable;
      Vue.set(state.vrbase.sandtable, state.selectImgIndex, sandtable);

      console.log("SET_EDIT_SANDTABLE===>", state.vrbase.sandtable)
    } else {
      state.vrbase.sandtable.push(sandtable);
    }
  },
  SET_SELECT_IMG_INDEX(state, index) {
    console.log("SET_SELECT_IMG_INDEX====>", index)
    state.selectImgIndex = index
  },
  ADD_SANDTABLE(state, sandtable) {
    console.log("ADD_SANDTABLE====>", sandtable)
    state.vrbase.sandtable.push(sandtable)
    console.log("ADD_SANDTABLE_ALL_SAANDTABLE", state.vrbase.sandtable)
  },
  DEL_SANDTABLE(state, index) {
    console.log("DEL_SANDTABLE====>", index)
    // Vue.delete(state.vrbase.sandtable,index);
    // Vue.delete(state.vrbase.sandtable,0);
    let a = state.vrbase.sandtable.splice(index, 1);
    console.log("刪除了====>", a)
    // state.vrbase.sandtable.splice(1, 1);
  },
  SELECT_SCENES(state, sceneId) {
    let Allsandtable = state.vrbase.sandtable
    if (Object.keys(state.vrbase).length > 0 && Allsandtable.length > 0) {
      for (let i = 0; i < Allsandtable.length; i++) {
        for (const scenes_id in Allsandtable[i].scenes) {
          if (scenes_id === sceneId) {
            Vue.set(state, 'selectImgIndex', i);
          }
        }
      }
    }
  }
}

const actions = {
  // 設置name
  setVRBase: ({ commit }, vrbase) => {
    // console.log(
    //   'setVRBase(action)',
    //   '\nvrbase:', vrbase
    // );
    commit("SET_VR_BASE", vrbase);
  },
  saveVRBase: ({ commit }, { vrbase, showLoading = false }) => {
    commit('SET_VR_BASE', vrbase);
    return new Promise((resolve, reject) => {
      if (showLoading) {
        message.loading({
          content: i18n.t('message.saving'),
          key: 'SaveVrKey',
        });
      }
      saveEditedWork(vrbase).then(res => {
        // fullModal.hidePreLoader();
        if (showLoading) {
          message.success({ content: i18n.t('message.saveSuccess'), key: 'SaveVrKey', duration: 1 })
        }
        // if(res && Object.keys(res.data).length > 0) {
        //   commit('SET_VR_BASE', res.data);
        //   console.log("vr保存成功=", res.data)
        // }
        resolve(res)
      }).catch(error => {
        // fullModal.hidePreLoader();
        // message.error({content: error, key: 'SaveVrKey', duration: 1})
        reject(error)
      })
    })
  },
  setCurrentScnId: ({ commit }, id) => {
    commit("SET_CURRENT_SCEN_ID", id);
  },
  delVRBase({ commit }) {
    commit('DEL_VR_BASE')
  },
  setCurrentGuidePointId: ({ commit }, id) => {
    commit('SET_CURRENT_GUIDE_POINT_ID', id)
  },
  setCurrentHlookat: ({ commit }, hlookat) => {
    commit('SET_CURRENT_HLOOKAT', hlookat)
  },
  loadScene: ({ commit }, id) => {
    loadScene(id);
    commit('SET_CURRENT_SCEN_ID', id)
  },
}

export default {
  state,
  mutations,
  actions,
};
